import _ from 'lodash';

export const selectEasyWalkThroughForm = state => _.get(state, ['easyWalkThroughForm'], {});

// export const selectEasyWalkThroughFormIsVisible = state => _.get(selectPropertyWalkThroughForm(state), ['isVisible'], false);

export const selectEasyWalkThroughFormStep = state => _.get(selectEasyWalkThroughForm(state), ['step'], 0);

export const selectEasyWalkThroughFormData = state => _.get(selectEasyWalkThroughForm(state), ['data'], {});
